<template>
  <div v-if="drawerVisible" class="wan-drawer-wrap">
    <el-drawer
      :show-close="false"
      :visible.sync="drawerVisible"
      class="wan-drawer"
      direction="rtl"
      append-to-body
    >
      <!-- 弹窗头部标题和内容 -->
      <div slot="title" class="title-wrap">
        <p>
          <i class="el-icon-s-unfold"></i>
        </p>
        <p class="title">{{ drawerParams.title }}</p>

        <slot v-if="drawerParams.operation" class="operation-btns"></slot>

        <div v-else-if="isShowOperation" class="operation-btns">
          <span
            ref="copy-url"
            @click="
              $utils.copyText(details.resUrl ? details.resUrl : details.fileUrl)
            "
          >
            复制地址
          </span>
          |
          <!-- 播放视频 -->
          <span @click="playVideo(details.fileUrl)">
            {{ drawerParams.type === 3 ? "播放 | " : "" }}
          </span>
          <!-- 打开h5 -->
          <span
            v-if="drawerParams.type === 6"
            @click="
              openH5({
                ...details,
                url: details.resUrl || details.fileUrl,
                title: details.resName,
              })
            "
          >
            预览 |
          </span>
          <span @click="$utils.downLoadFile(details)">下载</span>
        </div>
      </div>

      <!-- 插槽的内容 -->
      <div
        v-if="drawerParams.isDrawerContentSlot"
        class="drawer-content-wrap"
        :style="{
          height: `calc(100vh - 60px - ${
            drawerParams.isDrawerFooterSlot === 'no' ? 10 : 80
          }px)`,
        }"
        @scroll="drawerScroll"
      >
        <slot name="content"></slot>
      </div>

      <!-- 上传资源的内容 -->
      <div v-else class="drawer-content-wrap" @scroll="drawerScroll">
        <!-- 查看详情 -->
        <wan-resources-details
          v-if="drawerParams.drawerType === 3"
          ref="wan-resources-details"
          :drawer-details="details"
          :drawer-params="drawerParams"
          :drawer-visible="drawerVisible"
        ></wan-resources-details>

        <!-- 新增编辑 -->
        <wan-resources-upload
          v-else
          ref="wan-resources-upload"
          :drawer-details="details"
          :drawer-params="drawerParams"
          :drawer-visible="drawerVisible"
        ></wan-resources-upload>
      </div>

      <!-- 删除的提示 -->
      <wan-del ref="wan_del" @del="delData"></wan-del>

      <!-- 插槽的footer -->
      <slot v-if="drawerParams.isDrawerFooterSlot" name="footer"></slot>
      <!-- 默认的footer -->
      <div v-else class="wan-drawer-footer">
        <div class="wan-drawer-back" @click="onsubmit">
          <!--提交-->
          {{ this.drawerParams.title === "上传资源" ? "提交" : "返回" }}
        </div>
      </div>
    </el-drawer>

    <div v-if="isOpenH5" class="drawer-left">
      <div class="drawer-left__title">
        {{ playInfo.title }}
        <div
          v-if="[122].includes(Number(playInfo.fileType))"
          :class="activeScreen === 'pc' ? 'active-screen' : ''"
          class="pc-icon"
          @click="changeScreen('pc')"
        >
          pc
        </div>
        <div
          v-if="[122].includes(Number(playInfo.fileType))"
          :class="activeScreen === 'h5' ? 'active-screen' : ''"
          class="app-icon"
          @click="changeScreen('h5')"
        >
          m
        </div>
        <div
          v-if="playInfo.isScreenshot"
          class="pc-icon sure"
          @click="screenshot"
        >
          确定
        </div>
        <div class="pc-icon close" @click="closeH5">×</div>
      </div>
      <div class="iframe-wrap">
        <video
          v-if="[85, 119].includes(Number(playInfo.fileType))"
          id="videoID"
          :src="playInfo.url"
          :autoplay="!playInfo.isScreenshot"
          controls
          controlsList="nodownload noremoteplayback"
          style="width: 100%; height: 100%"
        ></video>
        <iframe
          v-else
          :src="playInfo.url"
          :style="{
            width: activeScreen === 'h5' ? '700px' : '100%',
            height:
              activeScreen === 'h5'
                ? 'calc(100vh - 60px)'
                : 'calc(100% / 16 * 9)',
          }"
          style="background: #fff"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import wanResourcesDetails from "@/components/wan-resources-details";
import wanResourcesUpload from "@/components/wan-resources-upload";
import del from "./del";
import { mapState } from "vuex";

export default {
  name: "wanDrawer",
  components: {
    "wan-resources-details": wanResourcesDetails,
    "wan-resources-upload": wanResourcesUpload,
    "wan-del": del,
  },

  props: {
    // 弹窗参数
    /**
     * @title 标题
     * @isDrawerFooterSlot 底部插槽
     * @isDrawerContentSlot 内容插槽
     * */
    drawerParams: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState(["userInfo"]),
    isShowOperation() {
      return (
        this.drawerParams.title !== "上传资源" &&
        this.drawerParams.type !== 1 &&
        this.drawerParams.type !== 2 &&
        this.drawerParams.type !== 5 &&
        this.$route.meta.type === "productService"
      );
    },
  },

  data() {
    return {
      drawerVisible: false,
      isOpenH5: false,
      playInfo: {},
      activeScreen: "h5",
      details: {},
    };
  },

  watch: {
    drawerVisible() {
      this.isOpenH5 = false;
    },
  },

  mounted() {
    this.$bus.on("openH5", (data) => {
      this.openH5(data);
    });
    this.$bus.on("closeH5", () => {
      this.isOpenH5 = false;
    });
    this.$bus.on("closeH5", () => {
      this.isOpenH5 = false;
    });
  },

  methods: {
    // 截图
    async screenshot() {
      let node = document.getElementById("videoID");
      console.log(node.currentTime, "currentTime");
      let url = await this.$utils.findVideoCover(
        this.playInfo.url,
        node.currentTime
      );
      // console.log(url);
      this.$bus.emit("submitScreenshot", url);
      this.isOpenH5 = false;
    },

    drawerScroll(e) {
      this.$bus.emit("drawerScroll", e);
    },

    // 选择pc/h5
    changeScreen(v) {
      this.activeScreen = v;
    },

    // 播放视频
    playVideo(url) {
      this.$refs["wan-resources-details"].playVideo(url);
    },

    // 打开h5
    openH5(data) {
      this.playInfo = data;
      this.isOpenH5 = true;
    },

    // 关闭h5
    closeH5() {
      this.isOpenH5 = false;
      this.$bus.emit("closeH5", false);
    },

    // 获取文档档夹详情
    getDetails({ resoureNo, linkeType }) {
      let api =
        linkeType === 0
          ? this.$http.getResoureDetail({ resoureNo })
          : this.$http.getCaseDetail({ id: resoureNo });

      return new Promise((resolve) => {
        this.$store.commit("setLoading", true);
        api.then(({ data }) => {
          this.details = {
            ...data,
            fileType: Number(data.fileType),
            resAscr: Number(data.resAscr),
          };
          this.activeScreen = this.details.screenModel === 0 ? "h5" : "pc";
          this.$store.commit("setLoading", false);
          resolve(true);
        });
      });
    },

    // 提交
    async onsubmit() {
      console.log(this.drawerParams.drawerType, "上传or新增");
      if (this.drawerParams.title !== "上传资源") {
        return (this.drawerVisible = false);
      }

      const wanResourcesUpload = this.$refs["wan-resources-upload"];

      if (wanResourcesUpload.classifyType) {
        wanResourcesUpload.pickClassify();
      }

      let ruleForm = wanResourcesUpload.ruleForm;
      let showImageList = wanResourcesUpload.showImageList;
      console.log(showImageList, "showImageList");
      // console.log(ruleForm, "ruileform");
      if (!ruleForm.fileType) return this.$message.warning("请选择资源格式！");
      if (!wanResourcesUpload.fileList.length && ruleForm.linkType === 0)
        return this.$message.warning("请选择文件！");
      if (!ruleForm.fileUrl && ruleForm.linkType === 1)
        return this.$message.warning("请输入引用链接！");
      if (!ruleForm.resClass && !ruleForm.customContentCate)
        return this.$message.warning("请选择档务分类！");
      if (!ruleForm.resName) return this.$message.warning("请选择资源名称！");

      this.$store.commit("setLoading", true);

      // 小程序分享图 coverUrl
      if (ruleForm.coverUrlRaw) {
        ruleForm.coverUrl = (
          await this.$utils.uploadFiles([{ raw: ruleForm.coverUrlRaw }])
        ).url;
      }
      // 空间展示图 freeCoverUrl
      if (showImageList && showImageList.length) {
        let list = [];
        for (let i = 0; i < showImageList.length; i++) {
          let item = showImageList[i];
          list.push({
            showId: item.showId,
            showType: item.showType,
            showUrl: item.showUrlRaw
              ? (await this.$utils.uploadFiles([{ raw: item.showUrlRaw }])).url
              : item.showUrl,
          });
        }
        ruleForm.showImageList = list;
      }
      // if (showImageList && showImageList.length && ) {
      //   ruleForm.freeCoverUrl = (
      //     await this.$utils.uploadFiles([{ raw: ruleForm.freeCoverUrlRaw }])
      //   ).url;
      // }
      // 文件 fileUrl
      let fileBool =
        wanResourcesUpload.fileList.filter((item) => item.raw).length > 0;
      if (fileBool) {
        let { url, unzip_url } = await this.$utils.uploadFiles(
          wanResourcesUpload.fileList
        );
        ruleForm.fileUrl = url;
        ruleForm.resUrl = unzip_url ? unzip_url : url;
      }

      let api =
        this.drawerParams.drawerType === 1
          ? this.$http.uploadResoure
          : this.$http.updateResoure;
      api({
        ...ruleForm,
        spaceId: this.userInfo.id,
        founder: this.userInfo.principal,
      }).then(() => {
        this.$store.commit("setLoading", false);
        this.$message.success("提交成功");
        this.drawerVisible = false;
        this.$bus.emit("getList");
      });
    },

    // del
    async delData({
      url,
      data,
      event = "getCustomList",
      args = { v: "getCustomerList" },
    }) {
      await this.$http[url](data);
      this.$message.success("删除成功");
      this.$refs.wan_del.delVisible = false;
      this.drawerVisible = false;
      this.$bus.emit(event, args);
    },
  },
};
</script>

<style lang="less" scoped></style>
